// @flow
import * as React from 'react';
import { Breadcrumb, Divider } from 'antd';
import { NavLink } from 'react-router-dom';
import { getTeamUrl } from 'Common';

const { Item } = Breadcrumb;

type Props = {
  supplier: Object
}

export default class extends React.PureComponent<Props> {

  render() {

    const { supplier } = this.props;

    return (

      <React.Fragment>

        <Breadcrumb separator="»">

          <Item>
            Home
          </Item>

          <Item>

            <NavLink to={getTeamUrl('suppliers')}>
              Suppliers
            </NavLink>

          </Item>

          <Item>
            { supplier.company_name }
          </Item>

        </Breadcrumb>

        <Divider type="horizontal" />
        
      </React.Fragment>

    )
  };
}
